/**
 * Propose de charger un script une fois la page chargée,
 * même si les événements du navigateur sont déjà passés.
 *
 * @param callback Fonction à appeler
 * @param options Options
 */
export function onPageReady(callback, { once } = { once: true }) {
    let toExecute = callback;

    if (once) {
        let done = false;
        toExecute = () => {
            if (!done) callback();
            done = true;
        };
    }

    if (document.readyState === 'complete') {
        toExecute();
    } else {
        document.addEventListener("readystatechange", () => {
            if (document.readyState !== 'complete') return;
            toExecute();
        });
    }
}
